import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CloseIcon from '@mui/icons-material/Close';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import KeyboardReturnOutlinedIcon from '@mui/icons-material/KeyboardReturnOutlined';
import { DataGrid } from '@mui/x-data-grid';

//custom components
import OrderStatus from '../../pages/General/OrderStatus'
import TrackingDrawer from '../../pages/General/TrackingDrawer'
import NewOrderCreateDrawer from '../General/NewOrder/NewOrderCreateDrawer'
import Printer from '../../pages/General/Printer'
import Date from '../../pages/General/Date'
import CarrierTracking from '../../pages/General/CarrierTracking'
import ShipmentRate from '../../pages/General/ShipmentRate'
import { fetchCustomerDetails } from '../Reports/Deliveries/trackingEventsSlice';
import WidthMaximize from './WidthMaximize'
import NorowsData from '../General/NorowsData'
import LinearProgress from '@mui/material/LinearProgress';


// mui components
import {
    Stack,
    Drawer,
    Card,
    Divider,
    IconButton,
    Tooltip,
    Box,
    Button,
    CardHeader,
    Modal,
    Typography
} from "@mui/material";

//actions
import {
    doPostTrackingNumberVoid,
    dopostTrackingNumberCloseManifest
} from '../Orders-new/ordersSlice';

// Re-architected modal overlay grid blueprint matching production system designs
const enterpriseVoidModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: 420 }, // Smooth scaling adaptations over compressed viewpoints
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    border: '1px solid #E2E8F0',
    p: 4,
    outline: 'none',
    overflow: 'hidden'
};
const LineItemsDrawer = ({ visible, order, onClose }) => {
    const dispatch = useDispatch();
    const profile = useSelector(state => state.auth.profile);
    const orders = useSelector(state => state.ordersNew);
    const orderShipments = useSelector(state => state.ordersNew && state.ordersNew.orderShipments);
    const [viewActionAnchorEl, setViewActionAnchorEl] = useState(null);
    const [openVoidConfirmModal, setOpenVoidConfirmModal] = useState(false)
    const [openManifestConfirmModal, setOpenManifestConfirmModal] = useState(false)
    const [trackingDrawerVisible, setTrackingDrawerVisible] = useState(false);
    const [trackingMessage, setTrackingMessage] = useState(null);
    const [printUrl, setPrintUrl] = useState("")
    const [isPrinted, setIsPrinted] = useState(true)

    const [isShipmentCreationFlow, setIsShipmentCreationFlow] = useState(false)
    const [newOrderFormData, setNewOrderFormData] = useState("");
    const [newOrderCreateDrawerVisible, setNewOrderCreateDrawerVisible] = useState(false);
    const [isDuplicateOrder, setIsDuplicateOrder] = useState(false);
    const [isReturnOrder, setIsReturnOrder] = useState(false);
    const [duplicateActionAnchorEl, setDuplicateActionAnchorEl] = useState(null);
    const [choosenTrackingNumber, setChoosenTrackingNumber] = useState(0);
    const [meta, setMeta] = useState(orders.ordersData.meta);
    const [isMultiPiece, setIsMultiPiece] = useState(false)
    const [drawerWidth, setDrawerWidth] = useState("80%");
    const [voidShipmentData, setVoidShipmentData] = useState({
        "tracking_numbers": "",
        "doc_ids": ""
    })
    const [manifestShipmentData, setManifestShipmentData] = useState({
        "tracking_numbers": "",
        "doc_ids": ""
    })
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
    };

    const handleViewActionClick = (event) => {
        setViewActionAnchorEl(event.currentTarget);
    }

    const label_url = (row) => {
        let url = ""
        if (row &&
            row.label &&
            row.label.url_detachable &&
            row.manifest &&
            typeof row.label.is_void_in_progress === "undefined"
        ) {
            url = row.label.url_detachable;
        } else if (row &&
            row.label &&
            row.label.url_direct_detachable &&
            row.manifest &&
            typeof row.label.is_void_in_progress === "undefined"
        ) {
            url = row.label.url_direct_detachable;
        }else if (row &&
            row.label &&
            row.label.url &&
            row.manifest &&
            typeof row.label.is_void_in_progress === "undefined"
        ) {
            url = row.label.url;
        } else if (row &&
            row.label &&
            row.label.url_direct &&
            row.manifest &&
            typeof row.label.is_void_in_progress === "undefined"
        ) {
            url = row.label.url_direct;
        }
        return url
    }

    const handleViewActionClose = () => {
        setViewActionAnchorEl(null);
    }

    const trackingCallback = (carriername, trackingNumber, message = null) => {
        setTrackingMessage(message)
        let apikey = (profile && profile.api_token) ? profile.api_token : "";
        const data = { 'tracking_number': trackingNumber }
        dispatch(fetchCustomerDetails(data, apikey))
        setTrackingDrawerVisible(true)
        let firstChar=trackingNumber.charAt(0);
        if(firstChar=='M'){
            setIsMultiPiece(true)
          }
    }
    const onCloseTracking = () => {
        setTrackingDrawerVisible(false);
    };

    const triggerVoidShipment = (trackingnumber, doc_id) => {
        setVoidShipmentData({
            "tracking_numbers": [trackingnumber],
            "doc_ids": [doc_id]
        })
        setOpenVoidConfirmModal(true)
    }

    const triggerManifestShipment = (trackingnumbers, doc_id) => {
        setManifestShipmentData({
            "tracking_numbers": [trackingnumbers],
            "doc_ids": [doc_id]
        })
        setOpenManifestConfirmModal(true)
    }

    const voidShipment = () => {
        var postData = {
            "tracking_numbers": voidShipmentData["tracking_numbers"],
            "ignore_errors": true
        }
        var updateOrderData = { "doc_ids": voidShipmentData["doc_ids"], "update_type": "void" }
        dispatch(doPostTrackingNumberVoid(profile.id,postData, profile.api_token, updateOrderData, orders.ordersData.meta))
        setOpenVoidConfirmModal(false)
        onClose()
    }

    const manifestClose = () => {
        var postData = {
            "tracking_numbers": manifestShipmentData["tracking_numbers"],
            "ignore_errors": true,
            "ignore_errors": true,
            "request_medium":"UI",
        }
        dispatch(dopostTrackingNumberCloseManifest(profile.id,postData, profile.api_token, orders.ordersData.meta))
        setOpenManifestConfirmModal(false)
        onClose()
    }

    const newOrderCreateCallback = (item, is_return,tracking_number) => {
        setNewOrderFormData(item);
        setChoosenTrackingNumber(tracking_number)
        setNewOrderCreateDrawerVisible(true)
        setIsReturnOrder(is_return)
        setDuplicateActionAnchorEl(null);
    }

    const newOrderCreateOnClose = () => {
        setNewOrderCreateDrawerVisible(false);
    }

    const actionButton = (row) => {
        let actionButtonDisable = true;

        if (row && 
            row.tracking_number && 
            row.tracking_number !== "" &&
            row.label && 
            row.manifest &&
            // Ensure void is not already in progress or completed
            row.label.is_voided === false &&
            typeof row.label.is_void_in_progress === "undefined" &&
            // Ensure manifest is still open
            row.manifest.is_closed === false
        ) {
            actionButtonDisable = false;
        }

        return actionButtonDisable;
    };

    const labelButton = (row) => {
        let labelButtonDisable = true;
        
        // Check if the label object exists
        if (row && row.label) {
            // Find any available URL
            const hasUrl = row.label.url_detachable || 
                        row.label.url_direct_detachable || 
                        row.label.url || 
                        row.label.url_direct;

            if (row.manifest && 
                row.label.is_voided === false && 
                hasUrl // This will be false if all URLs are "" or undefined
            ) {
                labelButtonDisable = false;
            }
        }
        return labelButtonDisable;
    }

    const returnlabelButton = (row) => {
        let isreturnlabelButtonDisable = false;

        if (row && row.label) {
            if (
                // Disable if tracking number is missing
                !row.tracking_number || 
                row.tracking_number === "" ||
                // Disable if it is already a return label
                row.label.is_return === true ||
                // Disable if the label has been voided
                row.label.is_voided === true
            ) {
                isreturnlabelButtonDisable = true;
            }
        } else {
            // If there is no label data at all, disable the return button
            isreturnlabelButtonDisable = true;
        }

        return isreturnlabelButtonDisable;
    };

    const columns = [
        {
            field: 'tracking_number',
            headerName: 'Tracking Number',
            headerClassName: 'super-app-theme--header',
            width: 250,

            renderCell: (params) => {
                let tracking_number = (params.row.tracking_number)
                    ? params.row.tracking_number : "-";
                let carrier_name = (params.row && params.row.label && params.row.label.carrier_name)
                    ? params.row.label.carrier_name : "-";
                let message = (params.row && params.row.manifest && params.row.manifest.is_closed === false)
                    ? "This shipment manifest is not yet closed" : null;
                let tracking = { "tracking_number": tracking_number, "carrier_name": carrier_name }
                return (
                    <CarrierTracking trackingItems={tracking} dispatchCallback={trackingCallback} carrierImageWidth="60px" message={message} />
                )
            }
        },
        {
            field: 'status',
            headerName: 'Status',
            minWidth: 180,
            flex: 1,
            renderCell: (params) => {
                let row = params.row
                if (
                    row &&
                    row.status
                ) {
                    return (
                        <OrderStatus orderStatus={row.status} />
                    )
                } else {
                    return "-"
                }
            }
        },
        {
            field: 'created_at',
            headerName: 'Shipment Date',
            minWidth: 180,
            flex: 1,
            renderCell: (params) => {
                let row = params.row
                if (
                    row &&
                    row.created_at
                ) {
                    return (
                        <Date date={row.created_at} />
                    )
                } else {
                    return "-"
                }
            }
        },
        {
            field: 'rate',
            headerName: 'Rate',
            flex: 1,
            minWidth: 120,
            renderCell: (params) => {
                return (
                    <ShipmentRate
                        billed_rate={params.row && params.row.rate && params.row.rate.customer_price}
                        api_rate={null} 
                        is_multi_piece={params.row && params.row.is_multi_piece}
                        is_voided={labelButton(params.row)}
                    />
                )
            }
        },
        {
            field: 'duties',
            headerName: 'Duties',
            flex: 1,
            minWidth: 120,
            renderCell: (params) => {
                return (
                    <ShipmentRate
                        billed_rate={params.row && params.row.rate && params.row.rate.duty_charge}
                        api_rate={null} 
                        is_multi_piece={params.row && params.row.is_multi_piece}
                        is_voided={labelButton(params.row)}
                    />
                )
            }
        },
        {
            field: 'action',
            headerName: 'Shipment Action',
            minWidth: 200,
            flex: 1,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                let row = params.row;
                return (
                    <Stack 
                        direction="row" 
                        spacing={1} 
                        alignItems="center" 
                        sx={{ 
                            height: '100%',
                            width: '100%',
                            '& .MuiIconButton-root': {
                                borderRadius: '8px',
                                p: 1,
                                transition: 'all 0.15s ease-in-out',
                                '&:hover': {
                                    backgroundColor: '#F1F5F9',
                                },
                                '&.Mui-disabled': {
                                    opacity: 0.38,
                                    cursor: 'not-allowed',
                                    backgroundColor: 'transparent'
                                }
                            }
                        }}
                    >
                        {/* 1. View Shipping Label URL Adornment */}
                        <Tooltip title="View Label" placement="top">
                            <IconButton
                                disabled={labelButton(row)}
                                style={{
                                    color: labelButton(row) ? 'rgba(0,0,0,.54)' : '#1976d2', // --- CORPORATE ACCENT MATRIX SYNC ---
                                    pointerEvents: labelButton(row) ? 'none' : 'auto',
                                    cursor: labelButton(row) ? 'not-allowed' : 'pointer'
                                }}
                            >
                                <RemoveRedEyeIcon fontSize="small" onClick={() => window.open(label_url(row))} />
                            </IconButton>
                        </Tooltip>

                        {/* 2. Print Shipping Label Pipeline Trigger */}
                        <Tooltip title="Print Label" placement="top">
                            <IconButton
                                onClick={handleViewActionClick}
                                disabled={labelButton(row)}
                                style={{
                                    color: labelButton(row) ? 'rgba(0,0,0,.54)' : '#1976d2',
                                    pointerEvents: labelButton(row) ? 'none' : 'auto',
                                    cursor: labelButton(row) ? 'not-allowed' : 'pointer'
                                }}
                            >
                                <LocalPrintshopIcon fontSize="small" onClick={() => { setPrintUrl(label_url(row)); setIsPrinted(false); }} />
                            </IconButton>
                        </Tooltip>

                        {/* 3. Void Active Dispatch Order Operation */}
                        <Tooltip title="Void Shipment" placement="top">
                            <IconButton
                                disabled={actionButton(row)}
                                style={{
                                    color: actionButton(row) ? 'rgba(0,0,0,.54)' : '#1976d2',
                                    pointerEvents: actionButton(row) ? 'none' : 'auto',
                                    cursor: actionButton(row) ? 'not-allowed' : 'pointer'
                                }}
                                onClick={() => triggerVoidShipment(row && row.tracking_number, order && order._id)}
                            >
                                <DeleteOutlineOutlinedIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>

                        {/* <span>
                            <Tooltip title="Return Shipment" placement="left-start">
                                <IconButton
                                    disabled={returnlabelButton(row)}
                                    style={{
                                        color: returnlabelButton(row) ? 'rgba(0,0,0,.54)' : '#1890ff',
                                        pointerEvents: returnlabelButton(row) ? 'none' : 'auto',
                                        cursor: returnlabelButton(row) ? 'not-allowed' : 'pointer'
                                    }}
                                    onClick={(event) => newOrderCreateCallback(row, true,row && row.tracking_number)}
                                >
                                    <KeyboardReturnOutlinedIcon />
                                </IconButton>
                            </Tooltip>
                        </span> */}
                    </Stack>
                );
            }
        }
    ];

    const getFinalData = (datas) => {
        let finalData = []
        for (var key of Object.keys(datas)) {
            let dataTemp = typeof datas[key] == "object" ? JSON.parse(JSON.stringify(datas[key])) : {}
            dataTemp["tracking_number"] = key
            finalData.push(dataTemp)
        }
        return finalData
    }

    return (
        <>
            <Printer isPrinted={isPrinted} setIsPrinted={setIsPrinted} print_url={printUrl} />
            <Modal
                open={openVoidConfirmModal}
                aria-labelledby="void-confirm-modal-title"
                aria-describedby="void-confirm-modal-description"
                closeAfterTransition
            >
                <Box sx={enterpriseVoidModalStyle}>
                    
                    {/* 1. Structural Dialog Accent Title Header */}
                    <Typography 
                        id="void-confirm-modal-title" 
                        variant="h6" 
                        component="h2" 
                        sx={{ 
                            fontWeight: 800, 
                            color: '#0F172A', 
                            mb: 1.5, 
                            textAlign: 'center',
                            fontSize: '16px'
                        }}
                    >
                        Void Shipment
                    </Typography>

                    {/* 2. Core Information Question Description Narrative Container */}
                    <Typography 
                        id="void-confirm-modal-description" 
                        variant="body2" 
                        sx={{ 
                            color: '#475569', 
                            fontWeight: 500, 
                            lineHeight: 1.6, 
                            mb: 4, 
                            textAlign: 'center' 
                        }}
                    >
                        Do you want to void this shipment? <br /> This pipeline transaction cannot be reversed.
                    </Typography>

                    {/* 3. Balanced Inline Core Control Execution Footers Bar */}
                    <Box 
                        sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center', 
                            gap: 1.5,
                            width: '100%'
                        }}
                    >
                        {/* Dismissal Cancel Operational Path */}
                        <Button 
                            variant="outlined" 
                            onClick={() => { setOpenVoidConfirmModal(false) }}
                            sx={{
                                textTransform: 'none',
                                borderRadius: '10px',
                                fontWeight: 700,
                                fontSize: '13.5px',
                                height: '38px',
                                px: 3.5,
                                borderColor: '#E2E8F0',
                                color: '#475569',
                                transition: 'all 0.15s ease-in-out',
                                '&:hover': {
                                    borderColor: '#CBD5E1',
                                    backgroundColor: '#F8FAFC',
                                    color: '#1E293B'
                                }
                            }}
                        >
                            No, Keep
                        </Button>

                        {/* Affirmative Database Mutation Commit Pipeline Trigger */}
                        <Button 
                            variant="contained" 
                            onClick={() => { voidShipment() }}
                            sx={{
                                textTransform: 'none',
                                borderRadius: '10px',
                                fontWeight: 700,
                                fontSize: '13.5px',
                                height: '38px',
                                px: 4.5,
                                boxShadow: 'none',
                                backgroundColor: '#1976d2', // --- CORPORATE ACCENT SELECTION SYSTEM TOKEN ---
                                color: '#FFFFFF',
                                transition: 'all 0.15s ease-in-out',
                                '&:hover': {
                                    backgroundColor: '#115293',
                                    boxShadow: 'none'
                                }
                            }}
                        >
                            Yes, Void
                        </Button>
                    </Box>

                </Box>
            </Modal>
            <Modal
                open={openManifestConfirmModal}
                aria-labelledby="manifest-confirm-modal-title"
                aria-describedby="manifest-confirm-modal-description"
            >
                <Box sx={style}>
                    <Typography style={{ textAlign: "center" }} id="manifest-confirm-modal-description" sx={{ mt: 2 }}>
                        Do you want to close manifest for this shipment?
                    </Typography>
                    <Typography style={{ marginTop: "10px", textAlign: "center" }}>
                        <Button variant="outlined" onClick={() => { setOpenManifestConfirmModal(false) }}>No</Button>
                        <Button variant="contained" style={{ marginLeft: "15px" }} onClick={() => { manifestClose() }}>Yes</Button>
                    </Typography>
                </Box>
            </Modal>
            <Drawer
                anchor="right"
                open={visible}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                PaperProps={{
                    sx: { 
                        width: drawerWidth,
                        backgroundColor: '#F8FAFC',
                        borderLeft: '1px solid #E2E8F0'
                    }
                }}
            >
                <Box sx={{ p: 3, width: '100%', boxSizing: 'border-box' }}>
                    <Card 
                        className="sc--cardhead--details"
                        sx={{ 
                            width: '100%',
                            backgroundColor: '#FFFFFF',
                            border: '1px solid #E2E8F0',
                            borderRadius: '16px',
                            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
                            overflow: 'hidden'
                        }}
                    >
                        {/* Drawer Component Main Structural Action Header */}
                        <CardHeader 
                            title={
                                <Typography variant="h6" component="h2" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '16px' }}>
                                    {(order && order.order && order.order.id) ? "Shipment Details for #" + order.order.id : "Shipment Details"}
                                </Typography>
                            } 
                            action={
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <WidthMaximize
                                        defaultWidth="80%"
                                        onToggle={(newWidth) => setDrawerWidth(newWidth)}
                                    />
                                    <IconButton 
                                        aria-label="settings" 
                                        onClick={onClose}
                                        sx={{ 
                                            color: '#64748B',
                                            '&:hover': { backgroundColor: '#F1F5F9', color: '#1E293B' }
                                        }}
                                    >
                                        <CloseIcon sx={{ fontSize: '20px' }} />
                                    </IconButton>
                                </Stack>
                            } 
                            sx={{ p: 2.5, borderBottom: '1px solid #E2E8F0', backgroundColor: '#FFFFFF' }}
                        />
                        
                        <Divider sx={{ borderColor: '#E2E8F0' }} />
                        
                        {/* Main Process Content Area Wrapper Grid */}
                        <Box className="sc--form--center" sx={{ p: 0, width: '100%', boxSizing: 'border-box' }}>
                            <DataGrid
                                sx={{
                                    border: 'none',
                                    backgroundColor: '#FFFFFF',
                                    overflow: 'hidden',
                                    '& .MuiDataGrid-topContainer': { backgroundColor: '#F8FAFC', '&::after': { display: 'none' } },
                                    '& .MuiDataGrid-columnHeaders': { backgroundColor: '#F8FAFC', borderBottom: '1px solid #E2E8F0', minHeight: '52px !important', maxHeight: '52px !important' },
                                    '& .MuiDataGrid-columnHeader': { color: '#475569', fontWeight: 700, fontSize: '13px', '&:focus, &:focus-within': { outline: 'none' } },
                                    '& .MuiDataGrid-row': { transition: 'background-color 0.15s ease-in-out', borderBottom: '1px solid #F1F5F9', alignItems: 'center', '&:hover': { backgroundColor: '#F8FAFC' }, '&.Mui-selected': { backgroundColor: 'rgba(25, 118, 210, 0.04)', '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.08)' } } },
                                    '& .MuiDataGrid-cell': { fontSize: '13.5px', color: '#334155', borderBottom: 'none', display: 'flex', alignItems: 'center', py: '12px', '&:focus, &:focus-within': { outline: 'none' } },
                                    '& .MuiLinearProgress-root': { height: '3px', backgroundColor: '#E2E8F0', '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } }
                                }}
                                getRowId={(row) => row.tracking_number}
                                rows={orderShipments?.data || []}
                                columns={columns}
                                columnVisibilityModel={{
                                    duties: profile && profile.hide_rate===true ? false : true,
                                    rate: profile && profile.hide_rate===true ? false : true,
                                }}
                                slots={{
                                    loadingOverlay: LinearProgress,
                                    noRowsOverlay: NorowsData // ✅ corrected key
                                }}
                                autoHeight={true}
                                disableColumnFilter={true}
                                disableColumnMenu={true}
                                disableSelectionOnClick={true}
                                rowsPerPageOptions={[]}
                                loading={orderShipments?.loading}
                            />
                        </Box>
                    </Card>
                </Box>
            </Drawer>
            <TrackingDrawer
                visible={trackingDrawerVisible} message={trackingMessage} isMultiPiece={isMultiPiece} onClose={onCloseTracking}
            />
             <NewOrderCreateDrawer
                visible={newOrderCreateDrawerVisible}
                reportName={"LINEITEM_DRAWER"}
                newOrderFormData={newOrderFormData}
                setNewOrderFormData={setNewOrderFormData}
                meta={meta}
                onClose={newOrderCreateOnClose}
                isDuplicateOrder={isDuplicateOrder}
                isReturnOrder={isReturnOrder}
                setIsReturnOrder={setIsReturnOrder}
                setNewOrderCreateDrawerVisible={setNewOrderCreateDrawerVisible}
                choosenTrackingNumber={choosenTrackingNumber}
                isShipmentCreationFlow={isShipmentCreationFlow}
            />
        </>
    )
}

export default LineItemsDrawer;